import { MouseEvent } from 'react'
import ChevronLeft from '@mui/icons-material/ChevronLeft'
import ChevronRight from '@mui/icons-material/ChevronRight'
import { Button } from '@mui/material'
import { LIMIT_PER_PAGE } from '../config'
import { useApprovalContext } from '../contexts'
import { t } from '@lingui/core/macro'

export const PaginationButtons = () => {
  const {
    page,
    requestsBySubmitter,
    requestsWithinDateRange,
    sortOptions,
    updateApprovalRequests,
  } = useApprovalContext() ?? {
    page: 0,
    requestsBySubmitter: [],
    requestsWithinDateRange: [],
    sortOptions: {
      order: 'desc',
      orderBy: 'created_at',
      offset: 0,
    },
    updateApprovalRequests: () => void {},
  }

  const requests = requestsBySubmitter ?? requestsWithinDateRange
  const totalRequestCount = requests.length
  const disableAll = totalRequestCount === 0
  const disablePrevious = disableAll || !sortOptions.offset
  const disableNext = disableAll || totalRequestCount < LIMIT_PER_PAGE

  return (
    <>
      <Button disabled={disablePrevious} size="small" onClick={handlePreviousButtonClick}>
        <ChevronLeft />
        {t`Previous`}
      </Button>
      <Button disabled={disableNext} size="small" onClick={handleNextButtonClick}>
        {t`Next`}
        <ChevronRight />
      </Button>
    </>
  )

  function handlePreviousButtonClick(e: MouseEvent<HTMLButtonElement>) {
    handleChangePage(e, page - 1)
  }

  function handleNextButtonClick(e: MouseEvent<HTMLButtonElement>) {
    handleChangePage(e, page + 1)
  }

  function handleChangePage(_: MouseEvent<HTMLButtonElement> | null, newPage: number) {
    void updateApprovalRequests({ ...sortOptions, offset: newPage * LIMIT_PER_PAGE })
  }
}
